module.exports = __webpack_public_path__ + "img/web_differ.a20c51db.png";